import _pt from "prop-types";
var _excluded = ["inversed"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { InfoCircleIconThin } from '../Icons';
import React from 'react';
import classNames from 'classnames';
export var TooltipIcon = function TooltipIcon(_ref) {
  var inversed = _ref.inversed,
      iconProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("span", {
    className: "ds-c-tooltip-icon__container"
  }, /*#__PURE__*/React.createElement(InfoCircleIconThin, _extends({
    className: classNames('ds-c-tooltip-icon', {
      'ds-c-tooltip-icon--inverse': inversed
    })
  }, iconProps)));
};
TooltipIcon.propTypes = {
  /*
     * Renders inversed version of icon
     */
  inversed: _pt.bool
};
export default TooltipIcon;